import {
  AccessType,
  BSCInputType,
  ConditionType,
  CranageType,
  FloorMaterial,
  FurniturePresence,
  GarageCategory,
  GarageMaterial,
  GarageStatus,
  GatesType,
  InputType,
  Layout,
  LiftType,
  ParkingLocationType,
  ParkingType,
  PermittedUseType,
  PlacementType,
  PurposeType,
} from '../../store/offer';

export const LandStatus: {
  [index: string]: string,
} = {
  farm: 'Фермерское хозяйство',
  forAgriculturalPurposes: 'Участок сельскохозяйственного назначения',
  forestArea: 'Участок лесного фонда',
  gardening: 'Садоводство',
  gardeningNonProfitPartnership: 'Садовое некоммерческое товарищество',
  individualHousingConstruction: 'Индивидуальное жилищное строительство',
  industrialLand: 'Земля промышленного назначения',
  industryTransportCommunications: 'Участок промышленности, транспорта, связи и иного не сельхоз. назначения',
  investmentProject: 'Инвестпроект',
  ofProtectedCategories: 'Особо охраняемых категорий',
  privateFarm: 'Личное подсобное хозяйство',
  reserve: 'Участок запаса',
  settlements: 'Участок поселений',
  suburbanNonProfitPartnership: 'Дачное некоммерческое партнерство',
  suburbanNonProfitSettlementsPartnership: 'Дачное некоммерческое партнерство поселений',
  waterArea: 'Участок водного фонда',
};

export const RoomType: {
  [index: string]: string,
} = {
  both: 'Смежно-изолированная',
  combined: 'Смежная',
  separate: 'Изолированная',
};

export const BuildingType: {
  [index: string]: string,
} = {
  aerocreteBlock: 'Газобетонный блок',
  block: 'Блочный',
  boards: 'Щитовой',
  brick: 'Кирпичный',
  foamConcreteBlock: 'Пенобетонный блок',
  gasSilicateBlock: 'Газосиликатный блок',
  monolith: 'Монолитный',
  monolithBrick: 'Монолитно-кирпичный',
  old: 'Старый фонд',
  panel: 'Панельный',
  stalin: 'Сталинский',
  wireframe: 'Каркасный',
  wood: 'Деревянный',
};

export const RepairType: {
  [index: string]: string,
} = {
  cosmetic: 'Косметический',
  design: 'Дизайнерский',
  euro: 'Евроремонт',
  no: 'Без ремонта',
};

export const WindowsViewType: {
  [index: string]: string,
} = {
  street: 'На улицу',
  yard: 'Во двор',
  yardAndStreet: 'На улицу и двор',
};

export const DecorationType: {
  [index: string]: string,
} = {
  fine: 'Чистовая',
  rough: 'Черновая',
  without: 'Нет',
};

export const PlacementTypeNames = {
  [PlacementType.ShoppingMall]: 'в торговом комплексе',
  [PlacementType.StreetRetail]: 'street-retail',
};

export const LayoutNames = {
  [Layout.Cabinet]: 'Кабинетная',
  [Layout.CorridorPlan]: 'Коридорная',
  [Layout.Mixed]: 'Смешанная',
  [Layout.OpenSpace]: 'Открытая',
};

export const InputTypeNames = {
  [InputType.CommonFromStreet]: 'Общий с улицы',
  [InputType.CommonFromYard]: 'Общий со двора',
  [InputType.SeparateFromStreet]: 'Отдельный с улицы',
  [InputType.SeparateFromYard]: 'Отдельный со двора',
};

export const BSCInputTypeNames = {
  [BSCInputType.CommonFromTheStreet]: 'Общий с улицы',
  [BSCInputType.CommonFromTheYard]: 'Общий со двора',
  [BSCInputType.SeparateFromTheStreet]: 'Отдельный с улицы',
  [BSCInputType.SeparateFromTheYard]: 'Отдельный со двора',
};

export const FloorMaterialNames = {
  [FloorMaterial.Asphalt]: 'Асфальт',
  [FloorMaterial.Concrete]: 'Бетон',
  [FloorMaterial.Laminate]: 'Ламинат',
  [FloorMaterial.Linoleum]: 'Линолеум',
  [FloorMaterial.Polymeric]: 'Полимерный',
  [FloorMaterial.ReinforcedConcrete]: 'Железобетон',
  [FloorMaterial.SelfLeveling]: 'Наливной пол',
  [FloorMaterial.Tile]: 'Плитка',
  [FloorMaterial.Wood]: 'Дерево',
};

export const FurniturePresenceNames = {
  [FurniturePresence.No]: 'Нет',
  [FurniturePresence.Optional]: 'По желанию',
  [FurniturePresence.Yes]: 'Есть',
};

export const AccessTypeNames = {
  [AccessType.Free]: 'Свободный',
  [AccessType.PassSystem]: 'Пропускная система',
};

export const ParkingTypeNames = {
  [ParkingType.Ground]: 'Наземная',
  [ParkingType.Multilevel]: 'Многоуровневая',
  [ParkingType.Open]: 'Открытая',
  [ParkingType.Roof]: 'На крыше',
  [ParkingType.Spontaneous]: 'Спонтанная',
  [ParkingType.Underground]: 'Подземная',
};

export const ParkingLocationTypeNames = {
  [ParkingLocationType.Internal]: 'На территории',
  [ParkingLocationType.External]: 'За территорией',
};

export const ParkingPurposeTypeNames = {
  [PurposeType.Cargo]: 'Для грузового транспорта',
  [PurposeType.Passenger]: 'Для легковесного транспорта',
};

export const ConditionTypeNames = {
  [ConditionType.CosmeticRepairsRequired]: 'Требуется косметический ремонт',
  [ConditionType.Design]: 'Дизайнерский ремонт',
  [ConditionType.Finishing]: 'Под чистовую отделку',
  [ConditionType.MajorRepairsRequired]: 'Требуется капитальный ремонт',
  [ConditionType.Office]: 'Офисная отделка',
  [ConditionType.Typical]: 'Типовой ремонт',
};

export const GatesTypeNames = {
  [GatesType.AtZero]: 'На нулевой отметке',
  [GatesType.DockType]: 'Докового типа',
  [GatesType.OnRamp]: 'На пандусе',
};

export const LiftTypeNames = {
  [LiftType.Cargo]: 'Грузовой',
  [LiftType.Escalator]: 'Эскалатор',
  [LiftType.Lift]: 'Лифт',
  [LiftType.Passenger]: 'Пассажирский',
  [LiftType.Telpher]: 'Тельфер',
  [LiftType.Travelator]: 'Траволатор',
};

export const CranageTypeNames = {
  [CranageType.Beam]: 'Кран-балка',
  [CranageType.Gantry]: 'Козловой кран',
  [CranageType.Overhead]: 'Мостовой кран',
  [CranageType.Railway]: 'Ж/д кран',
};

export const GarageCategoryNames = {
  [GarageCategory.BuiltIn]: 'Встроенный',
  [GarageCategory.Capital]: 'Капитальный',
  [GarageCategory.Samostroy]: 'Самострой',
  [GarageCategory.Shell]: 'Ракушка',
};

export const GarageMaterialNames = {
  [GarageMaterial.Brick]: 'Кирпичный',
  [GarageMaterial.Metal]: 'Металлический',
};

export const GarageStatusNames = {
  [GarageStatus.ByProxy]: 'По доверенности',
  [GarageStatus.Cooperative]: 'Кооператив',
  [GarageStatus.Ownership]: 'Собственность',
};

export const PermittedUseTypeNames = {
  [PermittedUseType.Agricultural]: 'Cельскохозяйственное использование',
  [PermittedUseType.BusinessManagement]: 'Деловое управление',
  [PermittedUseType.CommonUseArea]: 'Общее пользование территории',
  [PermittedUseType.HighriseBuildings]: 'Высотная застройка',
  [PermittedUseType.HotelAmenities]: 'Гостиничное обслуживание',
  [PermittedUseType.IndividualHousingConstruction]: 'Индивидуальное жилищное строительство (ИЖС)',
  [PermittedUseType.Industry]: 'Промышленность',
  [PermittedUseType.Leisure]: 'Отдых (рекреация)',
  [PermittedUseType.LowriseHousing]: 'Малоэтажное жилищное строительство (МЖС)',
  [PermittedUseType.PublicUseOfCapitalConstruction]: 'Общественное использование объектов капитального строительства',
  [PermittedUseType.ServiceVehicles]: 'Обслуживание автотранспорта',
  [PermittedUseType.ShoppingCenters]: 'Торговые центры',
  [PermittedUseType.Warehouses]: 'Склады',
};
